import {useEffect, useState} from "react";

const TermSelector_Review = ({
        term
    }) => { //YYYYMM
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if(isLoaded)
            return;
        setIsLoaded(true);
    }, []);

    /* Need a check to ensure from is before or equal to to */
    if(term === -1) {
        return (
        <div className="input-group term-selector">
            <input
                type="text"
                className="form-control"
                style={{textAlign:'center'}}
                value={"They are currently my advisor"}
                onChange={() => {}}
                disabled
            />
        </div>);
    }
    return (
        <div className="input-group term-selector">
            <input
                type="text"
                className="form-control"
                style={{textAlign:'center'}}
                value={
                    term%100 === 1 ? "Spring":
                    term%100 === 6 ? "Summer":
                    term%100 === 9 ? "Fall":
                    term%100 === 12 ? "Winter":
                    "Error"
                }
                onChange={() => {}}
                disabled
            />
            <span className="input-group-text">of</span>
            <input
                type="text"
                className="form-control"
                style={{textAlign:'center'}}
                value={Math.floor(term/100)}
                onChange={() => {}}
                disabled
            />
        </div>
    )
}

export default TermSelector_Review;